define('collections/calendar/day-items',[
    'underscore',
    'backbone',
    'moment',
    'utils',
    // collections
    'collections/calendar/items'
], function(
    _, Backbone, moment, U,
    // collections
    CCalendarItems
) {

    /**
     * Subclass used when the items order is persistent.
     */
    var CCalendarDayItems = CCalendarItems.extend({
        comparator: "position",
        initialize: function(models, opt) {
            if (opt) {
                this.date = opt.date ? opt.date : moment().format('YYYY-MM-DD');
            }

        },

        set: function(models, opt) {
            models = CCalendarDayItems.__super__.set.call(this, models, opt);
            this.updatePositions(opt);
            return models;
        },

        remove: function(models, opt) {
            models = CCalendarDayItems.__super__.remove.call(this, models, opt);
            this.updatePositions(opt);
            return models;
        },

        move: function(fromIndex, toIndex, options) {
            if (fromIndex === toIndex) return this;
            var item = this.at(fromIndex);
            // use the native remove to avoid calling updatePositions twice.
            CCalendarDayItems.__super__.remove.call(this, item, { silent: true });
            this.add(item, _.extend({ at: toIndex }, options));

            return this;
        },

        updatePositions: function(options) {
            // this.comparator = function(model) {
            //   return model.get('position');
            // }
            // this.sort();
            this.each(function(model, index) {
                model.updatePosition(index, this.date, options);
            }, this);
        },

    });

    return CCalendarDayItems;
});

